module.exports = __webpack_public_path__ + "imgs/star-full-gray.5336edb7d73d8fcf385058c2ae164e6e.svg";